import { SubscriptionPackageResponse } from '@docbay/schemas';
import axiosAuthInstance from './axiosAuthInstance';

/**
 * Retrieves a list of subscription packages.
 *
 * @returns A promise that resolves with an array of `SubscriptionPackageResponse` objects.
 */
export const getSubscriptions = () =>
  axiosAuthInstance('').get<SubscriptionPackageResponse[]>('/subscriptions');
